import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

const base = "TRAINER_DASHBOARD_PAGE_FORECAST";
export const SET_SELECTED_FACILITY = `${base}_SET_SELECTED_FACILITY`;

export interface SelectedFacilityType {
  type: string;
  selectedFacility: racehorse360.IFacility;
}

export const setSelectedFacility = (
  selectedFacility: racehorse360.IFacility
): SelectedFacilityType => {
  return {
    type: SET_SELECTED_FACILITY,
    selectedFacility
  };
};
